<template>
    <div>
        <div class="vx-row mt-3 flex justify-end">
			<div class="vx-col mt-2">
                <vs-button class="mr-5" @click="editTariffAuthor">
                    {{ $t('save') }}
                </vs-button>
				<RouterLink :to="'/author/' + $route.params.id + '/tariff-point'">
					<vs-button color="dark" type="border">{{ $t('goBack') }}</vs-button>
				</RouterLink>
			</div>
		</div>
        <h1>{{ $t(item) }}</h1>
        <vx-card class="my-8">
            <h1>{{ $t('authorCostPerPageH1') }}</h1>
            <div class="vx-row mt-3 flex">
                <div  :key="indextr"  v-for="(tr, indextr) in subjects" class="w-full ml-10">
                    <div class="site-info-row w-full">
                        <div class="site-info-row__head">
                            <div class="site-info-row__title">
                                {{ tr.nameWork }}
                            </div>
                            <div class="site-info-row__line"></div>
                        </div>
                        <div class="site-info-row__body">
                            <div  :key="indextr2"  v-for="(tr2, indextr2) in tr.subject" class="w-full">
                                <div class="site-info-row ml-10">
                                    <div v-if="indextr2 != 0" class="site-info-row__head">
                                        <div class="site-info-row__title">
                                            {{ tr2.nameSubject }}
                                        </div>
                                        <div class="site-info-row__line"></div>
                                    </div>
                                    <div class="site-info-row__body flex m-1">
                                        <div class="flex vx-col mr-2 mt-2">
                                            <div class="flex justify-center items-center m-2">
                                                Budget:
                                            </div>
                                            <div class="mb-2">
                                                <vs-input class="fsrInputPriceSubject" v-model="tr2.Budget" @input="tr2.Budget"></vs-input>
                                            </div>
                                        </div>
                                        <div class="flex vx-col mr-2 mt-2">
                                            <div class="flex justify-center items-center m-2">
                                                Standard:
                                            </div>
                                            <div class="mb-2">
                                                <vs-input class="fsrInputPriceSubject" v-model="tr2.Standard" @input="tr2.Standard"></vs-input>
                                            </div>
                                        </div>
                                        <div class="flex vx-col mr-2 mt-2">
                                            <div class="flex justify-center items-center m-2">
                                                Plus:
                                            </div>
                                            <div class="mb-2">
                                                <vs-input class="fsrInputPriceSubject" v-model="tr2.Plus" @input="tr2.Plus"></vs-input>
                                            </div>
                                        </div>
                                        <div class="flex vx-col mr-2 mt-2">
                                            <div class="flex justify-center items-center m-2">
                                                Premium:
                                            </div>
                                            <div class="mb-2">
                                                <vs-input class="fsrInputPriceSubject" v-model="tr2.Premium" @input="tr2.Premium"></vs-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
		</vx-card>

		<div class="vx-row mt-3 flex justify-end">
			<div class="vx-col mt-2">
                <vs-button class="mr-5" @click="editTariffAuthor">
                    {{ $t('save') }}
                </vs-button>
				<RouterLink :to="'/author/' + $route.params.id">
					<vs-button color="dark" type="border">{{ $t('goBack') }}</vs-button>
				</RouterLink>
			</div>
		</div>
    </div>
</template>

<script>
    import notifier from "@/mixins/notifier";
    import databaseManager from "@/mixins/databaseManager";

    export default {
        name: "TariffSchedule",
        mixins: [databaseManager, notifier],
        data() {
            return {
                subjects: [],
                item: null,
            }
        },
        methods: {
            async editTariffAuthor() {
                try {
                    const authorId = this.$route.params.id;
                    const websiteId = this.$route.params.item;

                    this.subjects = await this.dbSetAuthorCostPerPage(authorId, this.subjects, websiteId);

                    this.notifySuccess(this.$t('dataIsSaved'));
                } catch (e) {
                    this.notifyError(e.message);
                    if(e.errors){
                        Object.values(e.errors).forEach(err=>{
                            this.notifyError(err);
                        })
                    }
                }
			},
        },
        async created () {
            const role = this.$store.state.auth.role;
            const authorId = this.$route.params.id;
            const websiteId = this.$route.params.item;
            let request = await this.dbGetAuthorCostPerPage(authorId, websiteId);
            this.subjects = request.data;
            this.item = request.item;
        },
    }
</script>

<style lang="scss">
    .fsrInputPriceSubject {
        width: 60px;
    }
    .site-info-row {
        &__head {
            display: flex;
        }

        &__title {
            font-size: 16px;
            font-weight: 600;
            line-height: 13px;
        }

        &__line {
            flex-grow: 1;
            border-bottom: rgba(98, 98, 98, 0.7) solid 2px;
            margin-left: 13px;
        }

        &__body {
            margin-top: 23px;
        }
    }
</style>